module.exports = __webpack_public_path__ + "static/media/dropdown-icon.f3017647.svg";